import { request } from '@/common/utils/request'

export function getDiagnosisDetail(params) {
  return request
    .get({
      url: 'feidian.bdapp.diagnosis.getDetail',
      params,
    })
    .then(res => res.data)
}

export function getDiagnosisInit() {
  return request
    .get({
      url: 'feidian.bdapp.diagnosis.init',
    })
    .then(res => res.data)
}
